module.exports = global["jQuery"] = require("-!/srv/packages/dashboard/resources/assets/_gulp-builder/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/expose-loader?$!./~/jquery/dist/jquery.js-exposed
// module id = 70
// module chunks = 0 1